import React from 'react';
import Logo from '../../assets/images/logo.png';
import {Link} from 'react-router-dom';
import { lang } from '../../config/app.config';

const NotFound:React.FC = () =>{
  return(
    <div className="page-404">
      <div className="page-404-contents section-padding-2">
        <div className="text-center"> 
          <img src={Logo} alt="" />
        </div>
        <h4 className="text-22-primary text-center mt-1">404! <span className="ml-05 text-primary">Page not found !</span></h4>
        <div className="text-center mt-2"> 
          <Link to={'/'+lang} className="btn-primary p-05">Go to Home</Link>
        </div>
      </div>
    </div>
  );
}

export default NotFound;